import React, { Fragment } from "react";
import api from "../../../../api";
import { DownloadLink } from "../../../../components/render-file/DownloadLink";
import { ILeadActivity, formatDate, DateFormats } from "../../../../core";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";

interface INoteItemProps {
  activity: ILeadActivity;
}

export const FileItem: React.FunctionComponent<INoteItemProps> = (props) => {
  const p = props.activity;
  const { getActivityIcon } = useLeadActivities(api.lead);
  return (
    <Fragment>
      <li className="d-flex mb-3 position-relative zIndex-1 note-item">
        <div className="activity-icon rounded-circle bg-white shadow d-flex align-items-center justify-content-center mr-2 mt-2">
          <i className={getActivityIcon(p.type) + " text-gray-500"}></i>
        </div>
        <div className="activity-box bg-white arrow border rounded p-2 col">
          <div className="d-flex align-items-center mb-2 p-1">
            <div className="pl-0 col-12 font-sm font-weight-semibold mb-1 d-flex align-items-center">
              <DownloadLink
                file={p.file}
                target="_blank"
                className="text-primary d-inline-flex align-items-center py-1 px-2 pl-0 font-xxs rounded cursor-pointer"
              >
                <i className="icon-download-arrow mr-1"></i> Download{" "}
                {p.file?.originalname}
              </DownloadLink>
            </div>
          </div>
          <div className="row font-xs gutter-5 px-1 pb-1 pt-0 align-items-center">
            {p?.createdAt != null && (
              <div className="col-auto text-gray-500">
                {formatDate(p.createdAt, DateFormats.NormalDateFormat)} at{" "}
                {formatDate(p.createdAt, DateFormats.TimeOnlyFormat)}
              </div>
            )}
            <div className="activity-separator bg-gray-400 rounded-circle mx-1"></div>
            {p?.createdBy?.name != null && (
              <div className="col-auto text-gray-500">{p?.createdBy?.name}</div>
            )}
          </div>
        </div>
      </li>
    </Fragment>
  );
};
